import { useEffect, useState } from 'react'
import { navigate } from 'gatsby-link'

import { clearFormSession, useFirebolt } from '@iq-firebolt/client'
import useFormFlow from 'hooks/useFormFlow'
import useAnalytics from 'hooks/useAnalytics'
import { useGetApplication } from 'hooks/useGetApplication'
import { getCookie } from 'utils/cookie'

export default function useBbOurocardFormFlow() {
  const {
    stepsList,
    onChageStepHandler,
    onFireboltConnectionError,
    sendProposalModalName,
    closeSendFormModal,
    openedModals,
    onGoPreviousStep,
    currentStep,
    onBeforeChangeStepHandler,
  } = useFormFlow()

  const uploadedFilesState = useState({})

  const { remoteErrors, goNextStep, ...props } = useFirebolt()

  const { track } = useAnalytics()

  const [autofill, setAutofill] = useState({})
  const { application } = useGetApplication()

  useEffect(() => {
    const startSourceCookie = getCookie('start_source_url')
    const isLoggedCP = startSourceCookie && getCookie('start_source_url')?.includes('app')
    const cpEdittedApplication = isLoggedCP ? "consumidorpositivo-log" : "consumidorpositivo"

    const currentApplication = application === "cp" ? cpEdittedApplication : application
    if (!currentApplication) return
    setAutofill({ application: currentApplication })
  }, [application])

  useEffect(() => {
    const firstError = remoteErrors[0]?.validationResults[0]
    const mappedErrors = [
      "sms_token",
      "should_show_sortinghat",
      "email_not_allowed",
      "phone_not_allowed",
      "phone_already_registered",
      "federal_revenue_divergent_data",
      // TODO: Errors returned by API that are not yet handled in frontend
      "address_not_found",
      "incorrect_data",
    ]
    const isMappedError = mappedErrors.includes(firstError?.message)

    const currentFields = currentStep?.data?.fields?.map((field) => field.slug)
    const isFieldValidation = currentFields.includes(remoteErrors[0]?.slug)

    if (!!firstError && !isMappedError && !isFieldValidation) {
      navigate('/produto/bb/erro-no-processamento')
    }
  }, [remoteErrors])

  function customChangeStepHandler(transitionPayload) {
    onChageStepHandler(transitionPayload)
  }

  function customOnFormEnd() {
    track('formContinued', { ...currentStep.data, ...props })
    track('formSubmitted', { ...currentStep.data, ...props })

    sessionStorage.removeItem('bb-caf-url')
    sessionStorage.removeItem('bb-caf-success')

    setTimeout(() => {
      navigate('/produto/bb-ourocard/pedido-em-analise')
    }, 3000)
  }

  function customGoBack() {
    const isFirstStep = currentStep?.position === 1
    if (isFirstStep) {
      const fullPathname = window.location.pathname
      const [newPathName] = fullPathname.split('/bb')
      window.location.href = `${newPathName}/bb-ourocard`
      clearFormSession()
    } else {
      onGoPreviousStep()
    }
  }

  return {
    autofill,
    stepsList,
    customChangeStepHandler,
    customOnFormEnd,
    onFireboltConnectionError,
    sendProposalModalName,
    closeSendFormModal,
    openedModals,
    customGoBack,
    currentStep,
    uploadedFilesState,
    onBeforeChangeStepHandler,
    goNextStep,
  }
}
